/**
 * Keeps Elios A/B test body attributes in sync for runtime tools (IntelliGems, etc.).
 */
(function () {
  'use strict';

  if (window.__eliosABTestsInit) return;
  window.__eliosABTestsInit = true;

  var ATTRIBUTES = [
    'data-elios-bundle-test',
    'data-elios-cart-dock-test',
    'data-elios-direct-checkout-test',
    'data-elios-shipping-test',
    'data-elios-price-test',
    'data-elios-menu-bestsellers-test',
    'data-elios-sellout-test',
    'data-elios-ugc-stories-test',
    'data-elios-benefits-test',
    'data-elios-sticky-header-test',
    'data-elios-paid-shipping-test',
    'data-elios-gallery-image-test',
    'data-elios-social-proof-test',
    'data-elios-free-gifts-test',
    'data-elios-razor-action-up-test'
  ];

  function getTestRoot() {
    return document.body || document.documentElement;
  }

  function isEnabled(attr, enabledValue) {
    var root = getTestRoot();
    if (!root) return false;

    var value = root.getAttribute(attr);
    if (value == null && document.documentElement !== root) {
      value = document.documentElement.getAttribute(attr);
    }

    return String(value).toLowerCase() === enabledValue;
  }

  function syncClasses() {
    var body = document.body;
    if (!body) return;

    body.classList.toggle('elios-bundle-test-b', isEnabled('data-elios-bundle-test', 'false'));
    body.classList.toggle('elios-cart-dock-test-b', isEnabled('data-elios-cart-dock-test', 'false'));
    body.classList.toggle('elios-direct-checkout-test-b', isEnabled('data-elios-direct-checkout-test', 'false'));
    body.classList.toggle('elios-shipping-test-b', isEnabled('data-elios-shipping-test', 'false'));
    body.classList.toggle('elios-price-test-b', isEnabled('data-elios-price-test', 'false'));
    body.classList.toggle('elios-menu-bestsellers-test-b', isEnabled('data-elios-menu-bestsellers-test', 'false'));
    body.classList.toggle('elios-sellout-test-b', isEnabled('data-elios-sellout-test', 'true'));
    body.classList.toggle('elios-ugc-stories-test-b', isEnabled('data-elios-ugc-stories-test', 'true'));
    body.classList.toggle('elios-benefits-test-b', isEnabled('data-elios-benefits-test', 'true'));
    body.classList.toggle('elios-sticky-header-test-b', isEnabled('data-elios-sticky-header-test', 'false'));
    body.classList.toggle('elios-paid-shipping-test-b', isEnabled('data-elios-paid-shipping-test', 'false'));
    body.classList.toggle('elios-gallery-image-test-b', isEnabled('data-elios-gallery-image-test', 'true'));
    body.classList.toggle('elios-social-proof-test-b', isEnabled('data-elios-social-proof-test', 'true'));
    body.classList.toggle('elios-free-gifts-test-b', isEnabled('data-elios-free-gifts-test', 'true'));
    body.classList.toggle('elios-razor-action-up-test-b', isEnabled('data-elios-razor-action-up-test', 'true'));
  }

  function init() {
    syncClasses();

    var observer = new MutationObserver(syncClasses);

    if (document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ATTRIBUTES
      });
    }

    if (document.documentElement) {
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ATTRIBUTES
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
